import React, { Component } from 'react';

import { api } from 'services/api';
import { session } from 'services/session';

import './created-links.scss';
import dynamicInfo from 'images/icons/dynamic-info.svg';
import narrativIcon4 from 'images/logos/narrativ_icon_4.png';

class CreatedLinks extends Component {
	constructor(props) {
		super(props);

		this.state = {
			smartLinks: [],
		};
	}

	componentDidMount() {
		this.loadSmartLinks();
	}

	loadSmartLinks() {
		return api.get(`/api/v1/publishers/${session.orgId}/smart_links/list/`, {
			uid_created: `${session.userId}`,
		}).then((response) => {
			return this.setState({smartLinks: response.data.data});
		});
	}

	render() {
		const smartLinks = this.state.smartLinks.map((smartLink) => {
			return (
				<div className="smart-link-item" key={smartLink.bam_link_id}>
					<div className="details-container">
						<div className="product-name">
							{smartLink.product_info ? smartLink.product_info.item_data.name: ""}
						</div>
						<div className="shopLink-container">
							<img className="logo" src={narrativIcon4} alt="info" />
							<div className="shopLink">
								{smartLink.auction_url}
							</div>
							<button className="button-copy">Copy</button>
						</div>
						<div className="story-name">
							{smartLink.edit.edit_match_key}
						</div>
						<div className="channel">
							{smartLink.edit.channel}
						</div>
						<hr className="hr" />
						<div className="date">
							{smartLink.datetime_created}
							<button className="button-originalURL">Go to Original URL</button>
						</div>
					</div>
				</div>
			);
		});

		return (
		  <div className="created-links">
			  <div className="header">
				  Recently Created Links
				  <img className="info-icon" src={dynamicInfo} alt="info" />
			  </div>
			  {smartLinks}
		  </div>
		);
	}
}

export default CreatedLinks;
